<div class="form-row">
  <div class="col-12">
    <app-control-wrapper [control]="filerCodeControl" [helper]="'FORM_HELPER.FOR_CHANGE_CONTACT_TEEM'">
      <label control-label for="filerCode">{{ "FORM_LABEL.FILER_CODE" | translate }}</label>
      <input
        control-wrapper
        type="text"
        [formControl]="filerCodeControl"
        class="form-control"
        id="filerCode"
        name="filerCode"
        [mask]="'F*'"
        [patterns]="CUSTOM_MASK"
        [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
        [dropSpecialCharacters]="false"
      />
    </app-control-wrapper>
  </div>
  <div class="col-12">
    <div class="label">
      {{ "FORM_LABEL.PERMITTED_APPROVED_PORTS" | translate }}
    </div>
    <card-default *ngFor="let port of additionalPorts" [sticky]="true">
      <div class="row">
        <div class="col-6">
          {{ port.code + " " + port.description }}
        </div>
        <div class="col-6 text-right">
          <button *ngIf="!mainPort || mainPort.code !== port.code" type="button" class="btn btn-link" (click)="setMainPort(port.code)">
            {{ "BUTTON.SET_AS_MAIN" | translate }}
          </button>
          <div *ngIf="mainPort && mainPort.code === port.code" class="main-label">
            <i class="fa fa-check" aria-hidden="true"></i>
            {{ "FORM_LABEL.MAIN_PORT_OF_ENTRY" | translate }}
          </div>
          <button
            *ngIf="!mainPort || mainPort.code !== port.code"
            [title]="'BUTTON.REMOVE' | translate"
            type="button"
            class="ml-3 btn-icon"
            (click)="deletePort(port.code)"
          >
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </card-default>
    <card-default>
      <div *ngIf="!addAdditionalPortFormOpen; else addPortForm">
        <button class="btn btn-link" type="button" (click)="openAddPort()">
          <i class="fa fa-plus" aria-hidden="true"></i>
          {{ "BUTTON.ADD_PERMITTED_PORT_OF_ENTRY" | translate }}
        </button>
      </div>
      <ng-template #addPortForm>
        <div class="form-row">
          <div class="col-12">
            <auto-select
              [label]="'FORM_LABEL.ADD_PERMITTED_PORT'"
              [bindLabel]="['code', 'description']"
              [change]="searchPort()"
              [fc]="additionalPortControl"
            ></auto-select>
          </div>
        </div>
      </ng-template>
      <button
        *ngIf="addAdditionalPortFormOpen"
        card-footer
        class="btn btn-primary"
        type="button"
        (click)="savePort()"
        [disabled]="additionalPortControl.invalid"
      >
        {{ "BUTTON.SAVE" | translate }}
      </button>
    </card-default>

    <div class="hint">
      {{ "ON_BOARDING.ADD_ANOTHER_PORT_HINT" | translate }}
    </div>
  </div>
</div>
